<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item link router :to="{ name: 'home' }">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Κεντρική</v-list-item-title>
          </v-list-item-content>
        </v-list-item>



        <div v-if="showTransportationFeatures">
          <v-subheader v-if="showMenu('1.0')">Μεταφορικό</v-subheader>


          <v-list-item v-if="showMenu('1.1')" link router :to="{ name: 'newtransportationdocument' }" :disabled="subscriptionExpired">
            <v-list-item-action>
              <v-icon>mdi-truck</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Νέα φορτωτική</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="showMenu('1.2')" link :to="{ name: 'transportationdocuments' }">
            <v-list-item-action>
              <v-icon>mdi-truck-delivery</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Λίστα φορτωτικών</v-list-item-title>
            </v-list-item-content>
          </v-list-item>


          <!-- <v-list-item link v-on:click="transportationExport">
            <v-list-item-action>
              <v-icon>mdi-file-excel</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Εξαγωγή αρχείου</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->


        </div>




        <div v-if="showSalesFeatures">
          <v-subheader v-if="showMenu('2.0')">Πωλήσεις & Αγορές Εμπορευμάτων</v-subheader>

          <v-list-item v-if="showMenu('2.1')" link router :to="{ name: 'salesdocuments' }">
            <v-list-item-action>  
              <v-icon>mdi-file-multiple</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Παραστατικά πωλήσεων</v-list-item-title>
            </v-list-item-content>
          </v-list-item>



          <v-list-item v-if="showMenu('2.2')" link router :to="{ name: 'purchasedocuments' }">
            <v-list-item-action>  
              <v-icon>mdi-basket</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Παραστατικά αγορών</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="showMenu('2.2')" link router :to="{ name: 'acquisitiondocuments' }">
            <v-list-item-action>  
              <v-icon>mdi-file-certificate</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Τίτλοι κτήσης</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-subheader v-if="showMenu('9.0')">Παραγγελίες</v-subheader>

          <v-list-item v-if="showMenu('9.1')" link router :to="{ name: 'salesorderdocuments' }">
            <v-list-item-action>  
              <v-icon>mdi-clipboard-list</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Λίστα παραγγελιών</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="showMenu('9.2')" link router :to="{ name: 'newsalesorderdocumentinvoicepage' }">
            <v-list-item-action>  
              <v-icon>mdi-file-document-edit</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Τιμολόγηση παραγγελιών</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item v-if="showMenu('9.2')" link router :to="{ name: 'distribution-itineraries-per-day' }">
            <v-list-item-action>  
              <v-icon>mdi-file-cabinet</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Παραγγελίες δρομολογίων</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->


        <v-subheader v-if="showMenu('3.0')">Κινήσεις αποθήκης</v-subheader>

          <v-list-item v-if="showMenu('3.1')" link router :to="{ name: 'warehousedocuments' }">
            <v-list-item-action>  
              <v-icon>mdi-package-variant</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Δελτία αποθήκης</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="showMenu('3.2')" link router :to="{ name: 'newwarehousedocumentinvoice' }">
            <v-list-item-action>  
              <v-icon>mdi-receipt</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Τιμολόγηση ΔΑΠ</v-list-item-title>
            </v-list-item-content>
          </v-list-item>


          <v-list-item v-if="showMenu('3.3')" link router :to="{ name: 'internalshippingdocuments' }">
            <v-list-item-action>  
              <v-icon>mdi-swap-horizontal</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Δελτία ενδοδιακίνησης</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="showMenu('3.4')" link router :to="{ name: 'branchstocks' }">
            <v-list-item-action>  
              <v-icon>mdi-store</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Αποθέματα</v-list-item-title>
            </v-list-item-content>
          </v-list-item>





        </div>

        <div v-if="showServicesFeatures">
          <v-subheader v-if="showMenu('4.0')" >Υπηρεσίες</v-subheader>

          <!-- <v-list-item link router :to="{ name: 'newservicedocument' }" :disabled="subscriptionExpired">
            <v-list-item-action>
              <v-icon>mdi-file-document</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Νέο τιμολόγιο</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <v-list-item v-if="showMenu('4.1')" link router :to="{ name: 'servicedocuments' }">
            <v-list-item-action>  
              <v-icon>mdi-briefcase-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Λίστα τιμολογίων</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item link v-on:click="serviceExport">
            <v-list-item-action>
              <v-icon>mdi-file-excel</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Εξαγωγή αρχείου</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

        </div>

        <v-subheader v-if="showMenu('5.0')" >Συναλλασσόμενοι</v-subheader>

        <v-list-item v-if="showMenu('5.1')" link router v-bind:to="{ name: 'customers' }" :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Λίστα συναλλασσομένων</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
<!-- 

        <v-list-item link :disabled="subscriptionExpired">
          <v-list-item-action>
            <v-icon>mdi-account-box-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Προμηθευτές</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->


        <v-list-item v-if="showMenu('5.2')" link router v-bind:to="{ name: 'ledgers2' }" >
          <v-list-item-action>
            <v-icon>mdi-book-open-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Καρτέλες συναλασσομένων</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-subheader>Ταμείο</v-subheader> -->


        

        <v-subheader v-if="showMenu('6.0')" >Εισπράξεις & Πληρωμές</v-subheader>


        <v-list-item v-if="showMenu('6.1')" link :to="{ name: 'incomedocuments' }">
          <v-list-item-action>
            <v-icon>mdi-cash-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Λίστα εισπράξεων</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item link v-on:click="incomeExport">
            <v-list-item-action>
              <v-icon>mdi-file-excel</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Εξαγωγή αρχείου</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->


        <v-list-item v-if="showMenu('6.2')" link :to="{ name: 'paymentdocuments' }">
          <v-list-item-action>
            <v-icon>mdi-cash-minus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Λίστα πληρωμών</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        
        <v-list-item link router :to="{ name: 'newoffsettransaction' }">
          <v-list-item-action>
            <v-icon>mdi-scale-balance</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Νέος συμψηφισμός</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <div v-if="showServicesFeatures">
          <v-subheader v-if="showMenu('8.0')" >Έξοδα</v-subheader>

          <v-list-item v-if="showMenu('8.1')" link router :to="{ name: 'expensedocuments' }">
            <v-list-item-action>  
              <v-icon>mdi-cash-register</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Λίστα εξόδων</v-list-item-title>
            </v-list-item-content>
          </v-list-item>


        </div>

        
        <div v-if="showContracts">
            <v-subheader >Συμβάσεις</v-subheader>

            <v-list-item link router :to="{ name: 'contracts' }">
              <v-list-item-action>  
                <v-icon>mdi-pen</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Λίστα συμβάσεων</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </div>


      <v-list-item v-if="showMenu('7.0')" link router :to="{ name: 'reports' }">
          <v-list-item-action>
            <v-icon>mdi-chart-bar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Εκτυπώσεις</v-list-item-title>
          </v-list-item-content>
      </v-list-item>


        <div v-if="showMyDataFeatures">
          <v-subheader>myDATA</v-subheader>

          <v-list-item link router :to="{ name: 'pending-transmissions' }">
            <v-list-item-action>
              <v-icon>mdi-cloud-upload-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Εκκρεμή myDATA</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div v-if="showSettings">
          <v-list-item link router :to="{ name: 'settings' }">
            <v-list-item-action>
              <v-icon>mdi-settings</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Ρυθμίσεις</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link router :to="{ name: 'primer' }">
            <v-list-item-action>
              <v-icon>mdi-file-document-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Ρυθμίσεις Primer</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>

        <v-divider></v-divider>
        <v-list-item link @click="logoutMethod">
          <v-list-item-action>
            <v-icon>mdi-power</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Αποσύνδεση</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app :color="appBarColor" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title >{{ toolbarTitle }}</v-toolbar-title>

    </v-app-bar>

    <v-main>
      <v-system-bar v-if="subscriptionExpired" height="20" color="red lighten-2" dark>Η συνδρομή σας έχει λήξει, και δεν μπορείτε να δημιουργήσετε νέα παραστατικά.</v-system-bar>
      <v-system-bar v-else-if="subscriptionExpired == false && subscriptionDaysLeft < 14 && subscriptionDaysLeft >= 0" height="20" color="orange lighten-2" dark>Η συνδρομή σας θα ληξει σε {{subscriptionDaysLeft}} ημέρες.</v-system-bar>
      <v-container class="fill-height" fluid>
        <!-- 
        <v-row align="center" justify="center">
          <v-col class="text-center">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn :href="source" icon large target="_blank" v-on="on">
                  <v-icon large>mdi-code-tags</v-icon>
                </v-btn>
              </template>
              <span>Source</span>
            </v-tooltip>
          </v-col>
        </v-row>
        -->
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-footer :color="appBarColor" app class="d-flex justify-space-between">
      <span class="white--text">R2025.12d &copy; CLEVER DATA ΕΕ</span>
      <span class="white--text text-caption" v-if="buildSha">Build: {{ buildSha }} ({{ buildTime }})</span>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  props: {
    source: String,
  },

  data: () => ({
    drawer: true,
    appEnv: null,
  }),

  methods: {
    showMenu (menuId) {
      let userMenuConfig = this.$store.state.currentUser.user.menu_config

      // console.log(`called with value: [${userMenuConfig?.join()}] - ${userMenuConfig?.length}`)
      
      if (userMenuConfig == null)
        return true

      if ((userMenuConfig?.length > 1) == false)
        return true

      return (userMenuConfig.indexOf(menuId) >= 0)
    },

      axiosDownload(url, filename) {
        axios({
          url: url, 
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename); //or any other extension
          document.body.appendChild(link);
          link.click();

          // link.remove();
          // url.remove();
        });
      },

      logoutMethod() {
          this.$store.dispatch('currentUser/logout')
      },

      transportationExport() {
        this.axiosDownload('/api/exports/transportation', 'τιμολόγια (φορτωτικές).xlsx')
      },

      serviceExport() {
        this.axiosDownload('/api/exports/service', 'τιμολόγια παροχής.xlsx')
      },

      incomeExport() {
        this.axiosDownload('/api/exports/income', 'αποδειξεις εισπραξης.xlsx')
      }
  },

  created() {
    let token = localStorage.getItem('access-token')

    if (token == null) {
      this.logoutMethod()
      return
    }

    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`

    axios.get('/api/config')
      .then(response => {
        this.appEnv = response.data.env
      })
      .catch(() => {
        this.appEnv = null
      })

      axios.interceptors.response.use(function (response) {
        // Do something with response data
        return response;
      }, function (error) {
        
        if (error.response.status == 401) {
          // logoutMethod()
          console.log('not authorized -- caught by interceptor')
          // logoutMethod()
        }

        return Promise.reject(error);
      });
      // Add a 401 response interceptor
      /*
      axios.interceptors.response.use(function (response) {
          return response;
      }, function (error) {
          if (401 === error.response.status) {
              Vue.swal({
                  title: "Session Expired",
                  text: "Your session has expired. Would you like to be redirected to the login page?",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Yes",
                  closeOnConfirm: false
              }, function(){
                  window.location = '/login';
              });
          } else {
              return Promise.reject(error);
          }
      });
      */
      //console.log('yeee-haw')
      //Vue.swal('hey!')
      this.$store.dispatch('currentUser/getCurrentUser')
  },


  computed: {
    buildSha() {
      return process.env.MIX_BUILD_SHA;
    },
    buildTime() {
      return process.env.MIX_BUILD_TIME;
    },
    appBarColor() {
      if (this.appEnv && this.appEnv !== 'production') {
        return 'red darken-3'
      }
      return 'indigo'
    },
    toolbarTitle: {
      get() {
        // return ''
        let user = this.$store.state.currentUser.user

        if (user)
          return `${user.name} (${user.company.name})`
        else
          return ''
      }
    },

    subscriptionExpired: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user)
          return user.subscription_expired
        else
          return false
      }
    },

    subscriptionDaysLeft: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user)
          return user.subscription_days_left
        
        return -1
      }
    },

    showContracts: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user.company.contracts_features === true)
          return true

        return false
      }
    },

    showServicesFeatures: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user.company.services_features === true)
          return true

        return false
      }
    },

    showTransportationFeatures: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user.company.transportation_features === true)
          return true

        return false
      }
    },

    showSettings: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user.branch_id > 0)
          return false

        return true
      }
    },

    showSalesFeatures: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user.company.sales_features === true)
          return true

        return false
      }
    },

    showGefyresEpsilon: {
      get() {
        let user = this.$store.state.currentUser.user

        if (user.company.show_gefyres_epsilon === true)
          return true

        return false
      }
    },

    showMyDataFeatures: {
      get() {
        let user = this.$store.state.currentUser.user

        if (!user || !user.company)
          return true

        return user.company.use_mydata === true || user.company.use_primer === true
      }
    }
  }
};
</script>